<template>
  <div class="input-card">
    <slot></slot>
    <div class="input-card-btns">
      <div class="input-card-btn is-delete" @click="handleDelete">
        <i class="icon icon-delete"></i>删除此条
      </div>
      <div class="input-card-btn is-add" @click="handleAdd" v-if="isShowAdd">
        <i class="icon icon-add"></i>新增一条
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputCard",
  props: {
    isShowAdd: Boolean
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleDelete() {
      this.$emit("delete");
    },
    handleAdd() {
      this.$emit("add");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InputCard.vue